// extracted by mini-css-extract-plugin
export var container = "_a1-0";
export var icon = "_a1-1";
export var text = "_a1-2";